export const PRIMARY = '#D77D59';
export const DIVIDER = '#FFF3C8';

export const WHITE = '#FFF';

// Statistics cards
export const CARD_GREEN = '#0BC58B';
export const CARD_YELLOW = '#EADE56';
export const CARD_ORANGE = '#F99771';
